import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Button } from '../components/Button';
import { useAuthStore } from '../lib/auth';
import { AuthShell, TextField } from './Join';

export function OwnerSetupRoute() {
  const [bootstrapToken, setBootstrapToken] = useState('');
  const [password, setPassword] = useState('');
  const [adminPassphrase, setAdminPassphrase] = useState('');
  const bootstrapOwner = useAuthStore((s) => s.bootstrapOwner);
  const loading = useAuthStore((s) => s.loading);
  const error = useAuthStore((s) => s.error);
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const ok = await bootstrapOwner({ bootstrapToken, password, adminPassphrase });
    if (ok) navigate({ to: '/' });
  }

  return (
    <AuthShell title="Owner setup" blurb="Create the reserved FM owner account.">
      <form onSubmit={submit} className="space-y-4">
        <div className="rounded-md border border-ink/10 bg-surface-2 p-3 text-sm">
          Username: <span className="font-semibold">FM</span>
        </div>
        <TextField label="Bootstrap token" value={bootstrapToken} onChange={setBootstrapToken} type="password" />
        <TextField label="Password" value={password} onChange={setPassword} type="password" />
        <TextField
          label="Owner passphrase"
          value={adminPassphrase}
          onChange={setAdminPassphrase}
          type="password"
        />
        {error && <div className="text-sm text-danger">{error}</div>}
        <Button type="submit" size="lg" className="w-full" disabled={loading}>
          Create FM
        </Button>
      </form>
    </AuthShell>
  );
}
